import(/* webpackMode: "eager", webpackExports: ["WorkPage"] */ "C:\\sites\\enginuity\\components\\pages.jsx");
